export default __webpack_public_path__ + "5788bf310b115b976ddf62ece70013fa.png";